import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgLocation = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsxs("g", { id: "Icons/My Location", children: [
  /* @__PURE__ */ jsx("circle", { id: "Ellipse 26", cx: 9, cy: 9, r: 1, stroke: "#999999", strokeWidth: 2 }),
  /* @__PURE__ */ jsx("circle", { id: "Ellipse 27", cx: 9, cy: 9, r: 5.2, stroke: "#999999", strokeWidth: 1.6 }),
  /* @__PURE__ */ jsx("path", { id: "Vector 57", d: "M9 4L9 1", stroke: "#999999", strokeWidth: 2 }),
  /* @__PURE__ */ jsx("path", { id: "Vector 58", d: "M9 17L9 14", stroke: "#999999", strokeWidth: 2 }),
  /* @__PURE__ */ jsx("path", { id: "Vector 59", d: "M14 9L17 9", stroke: "#999999", strokeWidth: 2 }),
  /* @__PURE__ */ jsx("path", { id: "Vector 60", d: "M1 9L4 9", stroke: "#999999", strokeWidth: 2 })
] }) });
const ForwardRef = forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
